import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'hanson_faso',
} as IModuleProps;
